import { differenceInHours, parse } from "date-fns";

const calculateTimeDifference = (startDate, startTime, endDate, endTime) => {
  if (!startDate || !startTime || !endDate || !endTime) {
    return null;
  }

  try {
    const startDateTime = parse(`${startDate} ${startTime}`, 'yyyy-MM-dd HH:mm', new Date());
    const endDateTime = parse(`${endDate} ${endTime}`, 'yyyy-MM-dd HH:mm', new Date());

    const DatedifferenceInHours = differenceInHours(endDateTime, startDateTime);
    return DatedifferenceInHours;
  } catch (error) {
    return null;
  }
};

export default calculateTimeDifference;